import React from 'react';

interface SkeletonDashboardCardsDividendsSectionProps {
    children: React.ReactNode;
}

export const SkeletonDashboardCardsDividendsSection: React.FC<SkeletonDashboardCardsDividendsSectionProps> = ({
    children,
}) => <div className="flex flex-col gap-xsmall">{children}</div>;
